import BaseApi from './base.api'
import ApiService from '@services/api.service'

export default {
    ...BaseApi,
    ...{
        resource: 'parents',
        getFamily(params = null) {
            return ApiService.post(`parents-getFamily`, params)
        },
        saveSponsor(params = null) {
            return ApiService.post(`${this.resource}/sponsor`, params)
        },
        getTypes(params = null) {
            return ApiService.get(`${this.resource}/types`, params)
        },
        getMotherTypes(params = null) {
            return ApiService.get(`${this.resource}/mother-types`, params)
        },
        blockBulk(params = null) {
            return ApiService.post(`${this.resource}/blockBulk`, params)

        },
        unblockBulk(params = null) {
            return ApiService.post(`${this.resource}/unblockBulk`, params)

        },
    },
    getWorkSectorTypes(params = null) {
        return ApiService.get(`${this.resource}/work-sector-types`, params)
    },

    getParentByCodeOrCivilId(code) {
        return ApiService.get(`${this.resource}/by-code-or-civil-id/${code}`);
    },

}

